import { Flex, Image, Card, CardHeader, Text, CardBody, HStack, Button, Box, Badge } from '@chakra-ui/react';
import kcookingtrip from '../assets/images/kcookingtrip.png';
import dessertguardians from '../assets/images/dessertguardians.png';
import googlebtn from '../assets/images/google_btn.png';
import applebtn from '../assets/images/apple_btn.svg';
import uiInnerBg from '../assets/images/ui_inner_bg.png';
import { useNavigate } from "react-router-dom";

const cardStyle = (bg) => ({
  borderImage: `url(${bg}) 12 fill / 12px stretch`,
  background: "none",
  boxShadow: "none",
  borderRadius: 0,
});

function Home() {
  const navigate = useNavigate();

  const redirectToURL = () => {
    window.location.href = "https://kcookingtrip.onelink.me/YWsf/upisfprg";
  };

  return (
    <Flex direction="column" alignItems="center" flex="1" py={4} px={4}>

      {/* KCooking Trip */}
      <Card maxW="sm" width="100%" overflow="hidden" padding={2} mb={4} sx={cardStyle(uiInnerBg)}>
        <Image src={kcookingtrip} alt="k-cookingtrip" />
        <CardHeader>
          <Text fontSize="xl" fontWeight="bold" cursor="pointer" _hover={{ textDecoration: "underline" }} onClick={() => navigate("/kcookingsupport")}>
            KCookingTrip</Text>
          <Text fontSize="sm" color="gray.500">맛집의 탄생</Text>
        </CardHeader>
        <CardBody>
          <HStack spacing={6} justify="center">
            <Button onClick={redirectToURL} variant="unstyled">
              <Image src={applebtn} alt="Button 1" width="140px" />
            </Button>
            <Button onClick={redirectToURL} variant="unstyled">
              <Image src={googlebtn} alt="Button 2" width="140px" />
            </Button>
          </HStack>
        </CardBody>
      </Card>

      {/* Dessert Guardians */}
      <Card maxW="sm" width="100%" overflow="hidden" padding={2} sx={cardStyle(uiInnerBg)}>
        <Box position="relative">
          <Image src={dessertguardians} alt="dessert-guardians" />
          <Badge
            position="absolute"
            top={3}
            right={3}
            colorScheme="yellow"
            variant="solid"
            fontSize="xs"
            px={2}
            py={1}
            borderRadius="full"
          >
            열심히 개발중
          </Badge>
        </Box>
        <CardHeader>
          <Text fontSize="xl" fontWeight="bold">Dessert Guardians</Text>
          <Text fontSize="sm" color="gray.500">디저트 수호대</Text>
        </CardHeader>
        <CardBody>
          <Text fontSize="sm" color="gray.500">Coming Soon</Text>
        </CardBody>
      </Card>

    </Flex>
  );
}


export default Home;
